import axios from "axios";
import { markOffline, markOnline } from "./lib/offline";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lp-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// The service worker tags anything it had to serve from its own cache, so a read that only worked
// because of the cache still counts as being offline.
api.interceptors.response.use((res) => {
  const h = res.headers;
  const tagged = (typeof h?.get === "function" ? h.get("x-lp-offline") : null) ?? h?.["x-lp-offline"];
  if (tagged) markOffline();
  else markOnline();
  return res;
});

// The server ends idle sessions (2h admin, 24h shop). When it does, don't leave the app
// half-broken — drop the dead token and send them to sign in with a note.
api.interceptors.response.use(undefined, (error) => {
  if (!error.response) markOffline();
  const detail = error.response?.data?.detail;
  // The server tags an ended session with a header; the message text is only a fallback.
  const ended = error.response?.headers?.["x-session-ended"]
    || (typeof detail === "string" && detail.includes("inactivity") ? "idle"
      : typeof detail === "string" && detail.includes("signed out") ? "revoked" : "");
  if (error.response?.status === 401 && ended && localStorage.getItem("lp-token")) {
    localStorage.removeItem("lp-token");
    if (!window.location.pathname.startsWith("/login")) {
      window.location.assign(`/login?ended=${ended}`);
    }
  }
  return Promise.reject(error);
});

export default api;
